// liteupperdev
//export const API_URL = "https://liteupnigeriabackend-dev.onrender.com/api";


// liteupperProduction
export const API_URL = 'https://api.liteupper.com/api';

 
export const LOCAL_API =
  "https://liteupper.local:8000/api";

export const getApiUrl = () => {
  return (
    localStorage.getItem("API_URL") ||
    API_URL
  );
};

